import React, { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Dimmer, Loader, Image, Transition } from 'semantic-ui-react';
import { imageTypes, pdfType, videoTypes } from '~/Constants';
import CustomIcon from '../CustomIcon';
import notify from '../Notify';
import Word from '@assets/images/Word.png';
import Excel from '@assets/images/Excel.png';
import Documents from '@assets/images/Documents.png';
import { DownloadService } from '~/api/services/downloadFiles';
interface LazyLoadProps {
  name: string;
  alt?: string;
  id: string
  type: string
  apiUrl: string
}

const LazyLoadImage: React.FC<LazyLoadProps> = (props) => {
  const elementRef = useRef<HTMLElement>(null);
  const { name, alt, id, type, apiUrl } = props
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(true);
  const [src, setSrc] = useState('')
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(async (entry) => {
          if (entry.isIntersecting) {
            if (elementRef.current) {
              try {
                const response = await DownloadService.getImageUrl(apiUrl, { fileName: name })
                setSrc(response.data)
                setIsLoading(false);
              } catch (error) {
                setIsLoading(false);
                if (error?.response?.data) {
                  notify(error?.response?.data?.message, 'error');
                } else {
                  notify(t('General error'), 'error');
                }
              }
            }
            observer.disconnect();
          }
        });
      },
      {
        rootMargin: '0px',
        threshold: 0.1
      }
    );

    elementRef.current = document.getElementById(id)
    if (elementRef.current) {
      observer.observe(elementRef.current);
    }
  }, [id, type]);

  useEffect(() => {
    if (!isLoading) {
      setIsVisible(true);
    }
  }, [isLoading]);

  function renderItem() {
    if (imageTypes.find(imageType => imageType === type)) {
      return <Image src={src} alt={alt} />
    }
    else if (videoTypes.find(videoType => videoType === type)) {
      return <video src={src} />
    }
    else if (pdfType === type) {
      return <CustomIcon name='file pdf' size='massive' style={{ fontSize: '7em' }} />
    }
    else if (type === 'xlsx') {
      return <Image src={Excel} alt={alt} />
    }
    else if (type === 'docx') {
      return <Image src={Word} alt={alt} />
    }
    return <Image src={Documents} alt={alt} />
  }

  return (
    <Dimmer.Dimmable dimmed={false}>
      <Dimmer active={!isVisible} inverted>
        <Loader active={!isVisible} />
      </Dimmer>
      <Transition visible={isVisible} animation='fade' duration={300}>
        {renderItem()}
      </Transition>
    </Dimmer.Dimmable>
  );
};

export default LazyLoadImage;